var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8086,
    cy: 43.5513,
    r: 4.5,
    fill: "#B6B6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4598 36.1616C41.1736 34.8754 39.6466 33.8551 37.9661 33.159C36.2856 32.4629 34.4844 32.1047 32.6654 32.1047C30.8465 32.1047 29.0453 32.4629 27.3648 33.159C25.6843 33.8551 24.1573 34.8754 22.8711 36.1616",
    stroke: "#B6B6B6",
    strokeWidth: 3.62392,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3324 29.0854C45.3694 27.1224 43.0389 25.5652 40.474 24.5028C37.9092 23.4404 35.1602 22.8936 32.384 22.8936C29.6078 22.8936 26.8588 23.4404 24.294 24.5028C21.7291 25.5652 19.3986 27.1224 17.4355 29.0854",
    stroke: "#B6B6B6",
    strokeWidth: 3.62392,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21.5C50.3079 18.8079 47.1119 16.6724 43.5945 15.2155C40.0771 13.7585 36.3072 13.0086 32.5 13.0086C28.6928 13.0086 24.9229 13.7585 21.4055 15.2155C17.8881 16.6724 14.6921 18.8079 12 21.5",
    stroke: "#B6B6B6",
    strokeWidth: 3.62392,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcWifi);
export default __webpack_public_path__ + "static/media/stick-ic-wifi.ed5ef0774de4d2f330f259d1bcb3fcde.svg";
export { ForwardRef as ReactComponent };